// atoms/QuestionDesignSectionMenu.js

import React from 'react';

const QuestionDesignSectionMenu = ({ sections, selectedSectionIndex, handleSectionClick, viewMode }) => (
    <div className="subcomponent-top-menu">
        {sections.map((section, index) => (
            <button
                key={section.dataID}
                onClick={() => handleSectionClick(index)}
                className={selectedSectionIndex === index && viewMode !== 'logicView' ? 'active' : ''}
            >
                {section.dataText}
            </button>
        ))}
    </div>
);

export default QuestionDesignSectionMenu;
